
// 1. 点击记录来源
document.addEventListener('click', function (e) {
  const el = e.target.closest('a');
  if (!el) return;

  const entry = el.dataset.entry || '';
  const currentUrl = entry ? window.location.pathname : ''
  sessionStorage.setItem('fabriqueEntry', entry);
  sessionStorage.setItem('fabriqueCurrentUrl', currentUrl);
});


function onBack() {
  sessionStorage.setItem('fabriqueEntry', '')
  sessionStorage.setItem('fabriqueCurrentUrl', '')
}

window.addEventListener('popstate', onBack);
window.addEventListener('pageshow', function (e) {
  if (e.persisted) onBack();
  try {
    const nav = performance.getEntriesByType('navigation')[0];
    if (nav && nav.type === 'back_forward') onBack();
  } catch (err) { }
});


function getFeatureValue(feature, defaultValue, timeout = 3000) {
  return new Promise((resolve) => {
    const start = Date.now();
    let timer = null;

    const check = () => {
      try {
        const value = window._growthbook?.getFeatureValue?.(feature, defaultValue);
        if (value !== undefined && value !== null) {
          resolve(value);
          return;
        }
      } catch (err) {
        // 忽略异常
      }

      if (Date.now() - start < timeout) {
        timer = setTimeout(check, 100);
      } else {
        resolve(defaultValue);
      }
    };

    check();
  });
}

async function handleABImg(img) {
  if (!img || img.__abHandled) return;
  if (img?.getAttribute('data-img-type') === '1') return;
  img.__abHandled = true;
  const raw = img.getAttribute('data_ai_img_src');
  let aiImgs = [];
  try {
    aiImgs = JSON.parse(raw);
  } catch (e) {
    aiImgs = [];
  }
  if (!Array.isArray(aiImgs) || aiImgs.length === 0) return;

  const productId = img.getAttribute('data-product-id');
  if (!productId) return;

  const featureKey = img.getAttribute('data_ai_img_feature_id');
  let variant = '1';

  try {
    variant = await getFeatureValue(featureKey, '1', 2000);
  } catch (e) { }

  const wrapper = document.querySelector(
    `.fabrique-product-abTestBox-${productId}`
  );
  const input = document.querySelector('input[data-good-id]');
  if (input && input.value === productId) {
    input.setAttribute('data-ab-variant', variant);
  }

  wrapper?.setAttribute('data-ab-variant', variant);
  img.setAttribute('data-ab-variant', variant);
  const variantNum = Number(variant);
  if (!Number.isInteger(variantNum) || variantNum < 1) return;

  const imgIndex = variantNum - 1;
  const expImage = aiImgs[imgIndex];
  if (!expImage) return;
  /* ------------------ 替换图片 ------------------ */
  img.src = expImage + "?x-oss-process=image/format,webp/quality,Q_80/resize,w_1000";
  if (img.hasAttribute('srcset')) {
    img.setAttribute(
      'srcset',
      expImage + "?x-oss-process=image/format,webp/quality,Q_80/resize,w_1000"
    );
  }

}

(function () {
  if (!document.querySelectorAll) return;
  const SELECTOR = 'img.fabrique-product-image-abtest';
  function scan() {
    document.querySelectorAll(SELECTOR).forEach(img => {
      handleABImg(img);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  const observer = new MutationObserver(mutations => {
    for (const m of mutations) {
      if (m.type === 'childList') {
        m.addedNodes.forEach(node => {
          if (!(node instanceof HTMLElement)) return;

          if (node.matches?.(SELECTOR)) {
            handleABImg(node);
          } else {
            node
              .querySelectorAll?.(SELECTOR)
              .forEach(handleABImg);
          }
        });
      }
      if (
        m.type === 'attributes' &&
        m.attributeName === 'src' &&
        m.target.matches?.(SELECTOR)
      ) {
        handleABImg(m.target);
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['src']
  });

  window.__fabriqueABRefresh = scan;
})();




